import { DOC_FLOW_SENDING_ENTITY } from '../../../../constants/entity'
import { DOC_FLOW_TABLE_ACTIONS_COLUMN_WIDTH } from '../../DocFlow.constants'
import { useDocFlowSendingContext } from '../../DocFlow.hooks'
import { DocFlowPhaseTable } from '../../DocFlowPhaseTable'
import { updateSendingTableConfig } from '../DocFlowSending.api'
import { getSendingCommunicationTableFilterApi } from '../DocFlowSendingCommunicationTable'
import { DocFlowSendingResultTableRow } from '../DocFlowSendingResultTableRow'

function DocFlowSendingResultTable() {
  const { usersTableData } = useDocFlowSendingContext()

  return (
    <DocFlowPhaseTable
      TableRow={DocFlowSendingResultTableRow}
      entity={DOC_FLOW_SENDING_ENTITY}
      getFilterApi={getSendingCommunicationTableFilterApi}
      tableLoader={usersTableData}
      tableProps={{
        actionsColumnWidth: DOC_FLOW_TABLE_ACTIONS_COLUMN_WIDTH,
      }}
      updateTableConfig={updateSendingTableConfig}
    />
  )
}

export default DocFlowSendingResultTable
